import { InformationCircleIcon } from "@heroicons/react/outline";
import { FC, ReactNode } from "react";
import { memo } from "react";
import { cn } from "@gettactic/helpers";
import { Popover, PopoverContent, PopoverTrigger } from "@cmp-src/primitives";

interface Props {
  width?: number;
  size?: "sm" | "md" | "lg";
  position?: "top" | "right" | "bottom" | "left";
  testId?: string;
  children: ReactNode;
}

export const InfoTooltip: FC<Props> = memo(
  ({ width = 300, size = "md", position = "bottom", testId, children }) => {
    return (
      <Popover>
        <PopoverTrigger>
          <InformationCircleIcon
            className={cn(
              "info-tooltip ml-2 inline cursor-pointer text-neutral-400",
              {
                "h-4 w-4": size === "sm",
                "h-5 w-5": size === "md",
                "h-7 w-7": size === "lg"
              }
            )}
            data-testid={testId}
          />
        </PopoverTrigger>
        <PopoverContent side={position} style={{ width }} showArrow>
          {children}
        </PopoverContent>
      </Popover>
    );
  }
);
